<!--title -->
<app-modal-title [title]="formPageConfig.title|translate" [isShowClose]="true" (isCloseModal)="onClose()"></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="row">
      <!-- privateNumberBuyRequestStatus -->
      <div class="tw-w-full">
        <enum-select-search
          class="tw-w-full"
          label="common.status"
          enumName="PrivateNumberBuyRequestStatus"
          [control]="form?.get('privateNumberBuyRequestStatus')"
          [(value)]="model.privateNumberBuyRequestStatus"
          (valueChange)="onChangePrivateNumberBuyRequestStatus()"
          (error)="onClose()"
        >
        </enum-select-search>
      </div>

      <!-- smsSenderAgentId -->
      <div class="tw-w-full" *ngIf="isShowEnabledSmsSenderAgentId">
        <sms-sender-agent-select-search
          type="userAgentsByCp"
          [id]="privateNumberPriceSmsCp"
          [control]="form?.get('smsSenderAgentId')"
          [(value)]="model.smsSenderAgentId"
          label="common.smsCp"
          (onError)="onClose()"
        >
        </sms-sender-agent-select-search>
        <mat-slide-toggle
          [(ngModel)]="model.isService"
          formControlName="isService"
        >
          {{ pageVocabs + "form.fields.isService" | translate }}
        </mat-slide-toggle>
      </div>

      <!-- rejectionDescription -->
      <div class="tw-w-full" *ngIf="isShowRejectionDescription">
        <form-textarea
        *ngIf="model.privateNumberBuyRequestStatus !=PrivateNumberBuyRequestStatus.WaitingDocumentsUpload"
        class="tw-w-full"
        [label]="pageVocabs + 'form.fields.rejectionDescription'"
        [(value)]="model.rejectionDescription"
        [control]="form?.get('rejectionDescription')"
        [rows]="1"
      >
      </form-textarea>
        <form-textarea
        *ngIf="model.privateNumberBuyRequestStatus == PrivateNumberBuyRequestStatus.WaitingDocumentsUpload"
        class="tw-w-full"
        label="common.description"
        [(value)]="model.rejectionDescription"
        [control]="form?.get('rejectionDescription')"
        [rows]="1"
      >
      </form-textarea>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
